/**
 * @typedef {import('types/zendesk').ZendeskVariable} ZendeskVariable
 */

export const parseVariableDesk = (variable) => {
  const { name, zendesk_ticket_field, centridesk_ticket_field } = variable;
  const parsed = { name };

  if (zendesk_ticket_field?.desk_id && zendesk_ticket_field.id) {
    parsed.zendesk_ticket_field = {
      id: zendesk_ticket_field.id,
      type: zendesk_ticket_field.type,
      title: zendesk_ticket_field.title,
      equivalences: zendesk_ticket_field.equivalences,
      desk_id: zendesk_ticket_field.desk_id,
    };
  }

  if (centridesk_ticket_field?.key_name) {
    parsed.centridesk_ticket_field = centridesk_ticket_field;
  }

  return parsed.zendesk_ticket_field || parsed.centridesk_ticket_field ? parsed : null;
};

/**
 * @param {ZendeskVariable[]} value
 */

export const parseVariablesDeskCreate = (value = []) => {
  /**
   * @type {ZendeskVariable[]}
   *
   */
  const variablesDesk = [];
  (value || []).forEach((variable) => {
    if (!variable) return;
    const parsed = parseVariableDesk(variable);
    if (parsed) variablesDesk.push(parsed);
  });

  return variablesDesk;
};
